import { createFileRoute } from '@tanstack/react-router'

import { CustomerListScreen } from './-components/customer-list-screen.tsx'

export const Route = createFileRoute('/cs-tools/customer-list')({
  component: CustomerListScreen
})
